import React from 'react';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import QuizIcon from '@mui/icons-material/Quiz';
import AddIcon from '@mui/icons-material/Add';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PeopleIcon from '@mui/icons-material/People';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SubscriptionsTab from './SubscriptionsTab';
import ReceiptsTab from './ReceiptsTab';
import GenerateReceiptTab from './GenerateReceiptTab';
import AnalyticsTab from './AnalyticsTab';
import QuizLeadsTab from './QuizLeadsTab';
import QuizCreatorTab from './QuizCreatorTab';
import S3UploadTab from './S3UploadTab';
import CouponUsageTab from './CouponUsageTab';
import MagazinesTab from './MagazinesTab';
import WhatsAppTab from './WhatsAppTab';
import MemberAnalyticsTab from './MemberAnalyticsTab';
import AdminsTab from './AdminsTab';
import ManualSubscriptionsTab from './ManualSubscriptionsTab';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

/**
 * Single source of truth for the dashboard tabs. `onActivate` names the context
 * fetcher to call when the tab becomes visible (kept lazy, as before).
 */
export const TABS = [
  { id: 'subscriptions', label: 'Subscriptions', Component: SubscriptionsTab },
  {
    id: 'manual_subscriptions',
    label: 'Manual Subs',
    icon: <PersonAddIcon />,
    Component: ManualSubscriptionsTab
  },
  { id: 'whatsapp', label: 'WhatsApp', icon: <WhatsAppIcon />, Component: WhatsAppTab },
  { id: 'receipts', label: 'Receipts', Component: ReceiptsTab },
  { id: 'generate_receipt', label: 'Generate Receipt', Component: GenerateReceiptTab },
  { id: 'analytics', label: 'Analytics', icon: <AnalyticsIcon />, Component: AnalyticsTab, onActivate: 'fetchAnalytics' },
  { id: 'member_analytics', label: 'Member Analytics', icon: <PeopleIcon />, Component: MemberAnalyticsTab },
  { id: 'quiz_leads', label: 'Quiz Leads', icon: <QuizIcon />, Component: QuizLeadsTab, onActivate: 'fetchQuizLeads' },
  { id: 'quiz_creator', label: 'Quiz Creator', icon: <AddIcon />, Component: QuizCreatorTab, onActivate: 'fetchQuizzes' },
  { id: 's3_upload', label: 'S3 Upload', icon: <CloudUploadIcon />, Component: S3UploadTab },
  { id: 'coupon_usage', label: 'Coupon Usage', icon: <LocalOfferIcon />, Component: CouponUsageTab },
  { id: 'magazines', label: 'Magazines', icon: <MenuBookIcon />, Component: MagazinesTab, onActivate: 'fetchMagazines' },
  { id: 'manage_admins', label: 'Admins', icon: <AdminPanelSettingsIcon />, Component: AdminsTab }
];
